import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex flex-row items-center" }
const _hoisted_3 = { class: "text-red-lp-100 font-semibold" }
const _hoisted_4 = { class: "text-gray-lp-500 ml-1" }
const _hoisted_5 = {
  key: 0,
  class: "text-gray-lp-300 text-center px-20"
}
const _hoisted_6 = {
  key: 1,
  class: "text-gray-lp-500"
}
const _hoisted_7 = { class: "text-12px text-red-lp-1000" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" dan ukuran file tidak lebih dari ")
const _hoisted_9 = { class: "flex flex-row" }
const _hoisted_10 = { class: "text-gray-lp-300" }
const _hoisted_11 = { class: "text-red-lp-100 font-semibold whitespace-no-wrap" }
const _hoisted_12 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.files.length < _ctx.maxFile)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs.file.click())),
          onDragover: _cache[2] || (_cache[2] = e => _ctx.setDragAndDrop(e, true)),
          onDragleave: _cache[3] || (_cache[3] = e => _ctx.setDragAndDrop(e, false)),
          onDrop: _cache[4] || (_cache[4] = e => _ctx.onSubmitDrag(e)),
          class: 
        `${_ctx.customClass} flex flex-col justify-center cursor-pointer items-center text-12px border-2 border-dashed rounded-lg my-2 ${
          _ctx.isDragFile
            ? 'border-gray-lp-600 bg-gray-lp-100'
            : _ctx.isDataValidate
            ? 'border-red-lp-1000'
            : 'border-gray-lp-400'
        }`
      
        }, [
          _createVNode(_component_Icons, {
            name: "cloud-upload",
            class: "w-12 mb-2 text-gray-lp-1300"
          }),
          _createVNode("div", _hoisted_2, [
            _createVNode("span", _hoisted_3, _toDisplayString(_ctx.loadingUpload ? "Loading..." : "Klik Untuk Upload"), 1),
            _withDirectives(_createVNode("span", _hoisted_4, "atau drag and drop", 512), [
              [_vShow, !_ctx.loadingUpload && _ctx.isDraggable]
            ])
          ]),
          (_ctx.caption)
            ? (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(_ctx.caption), 1))
            : (_openBlock(), _createBlock("div", _hoisted_6, [
                _createTextVNode(_toDisplayString(_ctx.fileCaption) + " maks. size: ", 1),
                _createVNode("span", null, _toDisplayString(_ctx.maxSize) + " MB, maks. file : " + _toDisplayString(_ctx.maxFile), 1)
              ]))
        ], 34))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("p", _hoisted_7, [
      _createTextVNode(_toDisplayString(_ctx.captionError) + " ", 1),
      _withDirectives(_createVNode("span", null, [
        _hoisted_8,
        _createVNode("span", null, _toDisplayString(_ctx.maxSize) + " MB", 1)
      ], 512), [
        [_vShow, _ctx.maxSize]
      ])
    ], 512), [
      [_vShow, _ctx.isDataValidate]
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modelValue, (key, index) => {
      return (_openBlock(), _createBlock("div", { key: index }, [
        _createVNode("div", {
          class: 
          `
      ${_ctx.isDragFile ? 'border-gray-lp-600 bg-gray-lp-100' : 'border-gray-lp-400'}
      items-center text-12px justify-between flex flex-row border-2 border-dashed py-2 px-4 rounded my-2`
        
        }, [
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_Icons, {
              name: "attachment",
              class: "w-3 mr-3 text-gray-lp-600"
            }),
            _createVNode("div", _hoisted_10, _toDisplayString(_ctx.ellipsisString(key.name.toString())), 1)
          ]),
          _createVNode("div", _hoisted_11, [
            (_ctx.loadingUpload)
              ? (_openBlock(), _createBlock("span", _hoisted_12, "Loading..."))
              : (_openBlock(), _createBlock("span", {
                  key: 1,
                  onClick: ($event: any) => (_ctx.removeFile(index)),
                  class: "w-4 cursor-pointer"
                }, " Hapus ", 8, ["onClick"]))
          ])
        ], 2)
      ]))
    }), 128)),
    _createVNode("input", {
      type: "file",
      ref: "file",
      onChange: _cache[5] || (_cache[5] = e => (_ctx.isDragFile ? _ctx.onSubmitDrag(e) : _ctx.onSubmitClick(e))),
      accept: `${_ctx.type}`,
      class: "hidden",
      multiple: ""
    }, null, 40, ["accept"])
  ]))
}